import { useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";

const InactivityHandler = ({ children }) => {
  const navigate = useNavigate();
  const timeoutRef = useRef(null);

  const logoutUser = useCallback(() => {
    navigate("/Logout");
  }, [navigate]);

  const resetTimer = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(logoutUser, 30 * 60 * 1000);
  }, [logoutUser]);

  useEffect(() => {
    const events = ["mousemove", "mousedown", "keypress", "touchstart"];

    const handleActivity = () => resetTimer();

    events.forEach((event) => window.addEventListener(event, handleActivity));

    resetTimer();

    return () => {
      events.forEach((event) => window.removeEventListener(event, handleActivity));

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [resetTimer]);

  return <>{children}</>;
};

export default InactivityHandler;
